import { InMemoryCache, useReactiveVar } from "@apollo/client"
import { persistCache } from "apollo3-cache-persist"
import { InMemoryCache as _InMemoryCache } from "apollo-cache-inmemory"
import { persistCache as _persistCache } from "apollo-cache-persist"
import log from "../utils/log"
import { gql } from "@apollo/client"
import { ENTRY } from "./fields"
import client from "./client"
import {
  isEqual,
  transform,
  isObject,
  isString,
  isNumber,
  isBoolean,
  isNull,
  isArray,
  isPlainObject,
  isEmpty,
  clone,
  merge,
  cloneDeep,
} from "lodash"
import {
  YEARLY_REVIEW,
  MONTHLY_REVIEW,
  GET_ENTRIES,
  _GET_OPT_ENTRIES,
  MONTHLY_REVIEW_NORMALIZED,
} from "./queries"
import { verifyCacheAndNetworkSync } from "../functions/reviews"
import { v4 as uuidv4 } from "uuid"
import { USER_ENTRY_UPDATE } from "./fragments"
import { MONTHLY_REVIEW_DATA, YEARLY_REVIEW_DATA } from "./data"

const _cacheConfig = new InMemoryCache({
  addTypename: true,
  typePolicies: {
    // UserEntry: {
    //   keyFields: ["key"],
    // },
    Query: {
      fields: {
        currentEntry: {
          merge: false,
        },
        yearlyReview(currentValue, ref) {
          const data = merge(cloneDeep(YEARLY_REVIEW_DATA), currentValue)
          console.log("LOG: [cache/yearlyReview]", {
            data: { ...data },
            current: { ...currentValue },
            ref,
          })
          return data
        },
        monthlyReview(currentValue, ref) {
          const data = merge(cloneDeep(MONTHLY_REVIEW_DATA), currentValue)
          console.log("LOG: [cache/monthlyReview]", {
            data: { ...data },
            current: { ...currentValue },
            ref,
          })
          return data
        },
        reviewParentEntryByDate(_, ref) {
          let match = []
          try {
            const { args } = ref
            const { month, year } = args
            const userEntries = client.readQuery({
              query: GET_ENTRIES,
            })?.userEntries
            match = userEntries
              .filter(entry => {
                return month && year ? entry.type === "monthly review" : true
              })
              .filter(entry => {
                return !month && year ? entry.type === "yearly review" : true
              })
              .filter(entry => {
                return entry.review && month && year
                  ? JSON.parse(entry.review)?.month === month &&
                      JSON.parse(entry.review)?.year == year
                  : true
              })
              .filter(entry => {
                return entry.review && !month && year
                  ? JSON.parse(entry.review)?.year == year
                  : true
              })
            return match[0] || null
          } catch (err) {
            debugger //
            return null
          }
        },
        userEntriesRefById(_, ref) {
          const foundRef = ref.toReference({
            __typename: "UserEntry",
            id: ref.args.key,
          })
          return foundRef
        },
        userEntriesById(_, ref) {
          try {
            const { args, storeFieldName, toReference } = ref
            // const itemReference = toReference(storeFieldName)
            const optUserEntries = client.readQuery({
              query: GET_ENTRIES,
            })?.userEntries
            const foundEntry = optUserEntries.filter(
              entry => entry.key === args.key
            )
            if (foundEntry.length > 0) return foundEntry[0]
            else return null
          } catch (err) {
            debugger //_
            return null
          }
        },
        userEntries: {
          keyArgs: ["key"],
          merge(existing, incoming, { mergeObjects }) {
            try {
              let merged
              try {
                merged = mergeObjects(existing, incoming)
              } catch (err) {
                merged = incoming
              }
              return merged
            } catch (err) {
              debugger //_
              return incoming
            }
          },
        },
        userEntriesBy: {
          merge(existing, incoming, { mergeObjects }) {
            try {
              let merged
              try {
                merged = mergeObjects(existing, incoming)
              } catch (err) {
                merged = incoming
              }
              return merged
            } catch (err) {
              debugger //_
              return incoming
            }
          },
        },
      },
    },
  },
  // dataIdFromObject: object => object.key || null,
})
_cacheConfig.writeData = normalizedData => {
  // debugger
  const fields = Object.keys(normalizedData.data).map(key => `${key}\n`)
  _cacheConfig.writeQuery({
    query: gql`
      query WriteData {
        ${fields}
      }
    `,
    data: normalizedData.data,
  })
}
export const cacheConfig = _cacheConfig

if (typeof window !== "undefined") {
  persistCache({
    cache: _cacheConfig,
    storage: window.localStorage,
  })
}

export const cached = client => {
  const cache = !!client.cache ? client.cache : client
  return {
    read: (key, query) => {
      try {
        let results = client.readQuery({ query })
        if (results && results[key]) {
          return results[key]
        }
        return null
      } catch (error) {
        log("warn", ["cacheRequest (Read) Failed on client:", { error }])
        return null
      }
    },
    updateDeleted: (data, target, query) => {
      let cached,
        updated = {}
      try {
        // Query cache for data
        cached = cache.readQuery({ query })
        // Add newest document to the beginning of array
        if (
          cached &&
          typeof cached === "object" &&
          cached[target] &&
          Array.isArray(cached[target])
        ) {
          updated[target] = cached[target].filter(x => x.key !== data.key)
          log("log", [
            "cacheRequest.updateDeleted() updated existing cache",
            { target },
          ])
        } else {
          updated[target] = []
          log("log", [
            "cacheRequest.updateDeleted() updated empty cache",
            { target },
          ])
        }
        // Write new data to cache
        cache.writeQuery({
          query,
          data: updated,
        })
      } catch (error) {
        log("warn", ["cacheRequest.updateDeleted() FAILED", { error }])
      }
    },
    updateCreated: (data, key, query) => {
      let cached,
        updated = {}

      try {
        // Query cache for data
        cached = cache.readQuery({ query })
        // Add newest document to the beginning of array
        if (
          cached &&
          typeof cached === "object" &&
          cached[key] &&
          Array.isArray(cached[key])
        ) {
          cached[key].unshift(data.document)
          updated[key] = cached[key]
          log("log", [
            "cacheRequest.updateCreated() updated existing cache",
            { key },
          ])
        } else {
          updated[key] = [data.document]
          log("log", [
            "cacheRequest.updateCreated() updated empty cache",
            { key },
          ])
        }
        // Write new data to cache
        cache.writeQuery({
          query,
          data: updated,
        })
      } catch (error) {
        log("warn", ["cacheRequest.updateCreated() FAILED", { error }])
      }
    },
    updateEdited: (data, key, query, index) => {
      cache.writeFragment({
        id: data.document.key,
        fragment: gql`
          fragment thisEntry on UserEntry {
            ${ENTRY}
          }
        `,
        data: data.document,
      })
      log("log", [
        "cacheRequest.updateEdited() updated existing cache",
        { key, index, data },
      ])
      return
    },
  }
}

/**
 * Deep diff between two object, using lodash
 * @param  {Object} object Object compared
 * @param  {Object} base   Object to compare with
 * @return {Object}        Return a new object who represent the diff
 */
function _diffCheckObject(object, base) {
  return transform(object, (result, value, key) => {
    if (!isEqual(value, base[key])) {
      result[key] =
        isObject(value) && isObject(base[key])
          ? _diffCheckObject(value, base[key])
          : isString(value) &&
            isString(base[key]) &&
            value.includes("{") &&
            base[key].includes("{")
          ? _diffCheckObject(JSON.parse(value), JSON.parse(base[key]))
          : value
    }
  })
}

export function diffCheckCacheWrite(read, data) {
  read = _prepDataForDiffCheck(read)
  data = _prepDataForDiffCheck(data)
  if (Object.keys(read).length !== Object.keys(data).length)
    return { keyCountDiff: true }
  return _diffCheckObject(read, data)
}

function _unserializeCacheDocumentFields(data) {
  if (!isObject(data)) return data
  function maybeUnserialize(data) {
    try {
      return JSON.parse(data)
    } catch (err) {
      return data
    }
  }
  return Object.keys(data).reduce((result, key) => {
    result[key] = maybeUnserialize(data[key])
    // debugger
    return result
  }, {})
}

function _flattenCacheDocument(o, prefix = "", result = {}, keepNull = true) {
  if (isString(o) || isNumber(o) || isBoolean(o) || (keepNull && isNull(o))) {
    result[prefix] = o
    return result
  }

  if (isArray(o) || isPlainObject(o)) {
    for (let i in o) {
      let pref = prefix
      if (isArray(o)) {
        pref = pref + `[${i}]`
      } else {
        if (isEmpty(prefix)) {
          pref = i
        } else {
          pref = prefix + "." + i
        }
      }
      _flattenCacheDocument(o[i], pref, result, keepNull)
    }
    return result
  }
  return result
}

function _prepDataForDiffCheck(data) {
  if (!isObject) return data
  return _flattenCacheDocument(_unserializeCacheDocumentFields(data))
}

/**
 * Determines if a cached document and a provided data object are equal.
 *
 * @param {string} id the ID of the cached document
 * @param {{string: any}} data        the data to be compared to existing document
 * @param {string} typename           the cached document's typename
 * @param {string} fields             a list of fields in the document
 * @param {{fragment: any}} options   additional options to handle `readFragment` (eg, providing the entire fragment)
 */
export function diffFragment(
  id,
  data,
  typename,
  fields,
  options = { fragment: null }
) {
  let read,
    check,
    isDiff = true
  try {
    if (fields)
      read = readFragment({
        id,
        fragment: gql`
         fragment DiffCache on ${typename} {
           ${fields}
         }
       `,
      })
    if (options.fragment) {
      read = readFragment({
        id,
        fragment: options.fragment,
      })
    }
    try {
      check = diffCheckCacheWrite(read, data)
      isDiff = Object.keys(check).length > 0
    } catch (err) {
      console.warn(
        `LOG: [diffFragment] error parsing string value on second level. Setting \`isDiff\` to \`true\` with message: ${err.message}`
      )
      console.log(err)
      isDiff = true
    }
  } catch (err) {
    console.warn(
      `diffCache's \`readFragment\` operation failed with an error: ${err.message}`
    )
  }

  // console.log("LOG: [diffFragment]", {
  //   read: _prepDataForDiffCheck(read),
  //   data: _prepDataForDiffCheck(data),
  // })

  // debugger
  return isDiff
}

/**
 * Determines if a cached document and a provided data object are equal.
 *
 * @param {any} query the query to compare against
 * @param {{[key: string]: any}} data the data to compare against the query result
 */
export function diffQuery(query, data) {
  /** By default, true.  In the case of error checking diff, result will assume a change */
  let isDiff = true
  try {
    /** Read the current document from cache */
    const read = readQuery({ query })
    /** If document exists, perform a deep comparison between the current and new data */
    if (read) isDiff = !isEqual(read[Object.keys(read)[0]], data)
  } catch (err) {
    console.warn(
      `diffCache's \`readFragment\` operation failed with an error: ${err.message}`
    )
  }
  // debugger
  return isDiff
}

/**
 * A proxy for ApolloCache's `readFragment`. Reads a cached document with a limited
 * number of it's fields.
 * See {@link https://www.apollographql.com/docs/react/caching/cache-interaction/#readfragment|Documentation}
 *
 * @param {import("apollo-cache").DataProxy.Fragment<any>} options required options for operation
 * @param {string} label label to provide error reference
 * @example
 * ```
 * cache.readPartialDocument({
 *  id: entry_id,
 *  fragment: gql`
 *    fragment SomeUniqueName on SomeTypeName {
 *      someField
 *    }
 *  `
 * })
 * ```
 */
export function readFragment(options, label = "unlabeled") {
  try {
    const read = client.readFragment(options)
    if (read) return { ...read }
    return read
  } catch (err) {
    console.error(err)
    throw Error(`Cache readFragment failed from \`${label}\``)
  }
}

/**
 * A proxy for ApolloCache's `readQuery`. Runs a full graphql query on the cache
 * returning null if any of the requested fields are not present.  This needs to
 * conform the structure of one of the graph's supported queries.
 * See {@link https://www.apollographql.com/docs/react/caching/cache-interaction/#readquery|Documentation}
 *
 * @param {import("apollo-cache").DataProxy.Query<any>} options required options for operation
 * @param {string} label label to provide error reference
 * @example
 * ```
 * cache.readQuery({
 *  query: gql`
 *    query ReadSomething($id: string!) {
 *      something(id: $id) {
 *        fieldA
 *        fieldB
 *      }
 *    }
 *  `,
 *  variables: {
 *    id: 'um0XtCTXF9XDfgfk9V2'
 *  }
 * })
 * ```
 */
export function readQuery(options, label = "unlabeled") {
  try {
    const result = client.readQuery(options)
    if (typeof result === "object") return clone(result)
    else return result
  } catch (err) {
    console.error(err)
    throw Error(`Cache readQuery failed from \`${label}\``)
  }
}

/**
 * Generate options for `writeFragment` in order to execute a rollback based on
 * the data provided, intended for the cache/network update. An rollback function
 * is provided as a callback on `writeFragment` in the case of a network error.
 *
 * @param {import("apollo-cache").DataProxy.WriteFragmentOptions<any, import("apollo-boost").OperationVariables>} options the ID of the cached document
 * @param {{
 *  label: string
 *  next: null|function
 *  rollbackDocType: "UserEntry"
 * }} support options label to provide error reference, other optiosn
 */
function _getRollbackData(options, support) {
  let data,
    rollbackOptions,
    documentType = support.rollbackDocType,
    id = options.id,
    /** Create a field series set based on the updated fields in data */
    fragmentFields = Object.keys(options.data).reduce((result, curr) => {
      return `${result ? result + "\n" : result}${curr}`
    }, "")

  try {
    switch (documentType) {
      case "UserEntry":
        /** Read the current data from the cache */
        const read = readFragment({
          id,
          fragment: gql`
            fragment RollbackDocument${documentType} on ${documentType} {
              ${ENTRY}
            }
          `,
        })
        /** Create an object of data to roll back to based on updated fields */
        data = Object.keys(options.data).reduce((result, key) => {
          result[key] = read[key]
          return result
        }, {})
        /** Create options to provided to `writeFragment` to execute the rollback */
        rollbackOptions = {
          id, // -----------------------------> v Note: fragment name must be unique
          fragment: gql`
            fragment RollbackDocument${documentType}Restore${new Date().getTime()} on ${documentType} {
              ${fragmentFields}
            }
          `,
          data,
        }
      default:
        break
    }
  } catch (err) {
    /** Alerts user to issue and redirects to main account loading route */
    _throwRollbackError(err, "_getRollbackData")
  }
  return rollbackOptions
}

/**
 * Throws an error forcing reload in the case of an unrecoverable cache/network update error
 * @param {typeof Error} err error instance
 * @param {string} label custom label provided to error console output
 */
function _throwRollbackError(err, label) {
  console.log(`LOG: [${label}] failed`)
  console.error(err)
  alert(
    `There was an unrecoverable error while editing this review.  We will attempt to refresh the application data now.  If the issue persists, please contact support.`
  )
  debugger //_
  window.location.assign("/a/account")
}

/**
 * Executes a cache rollback based on the most recent cache update from `writeFragment`.
 *
 * @param {import("apollo-cache").DataProxy.WriteFragmentOptions<any, import("apollo-boost").OperationVariables>} rollbackDataOptions options for cache rollback
 * @param {*} support support options
 */
function _performCacheRollback(rollbackDataOptions, support) {
  try {
    console.log("LOG: [_performCacheRollback]", {
      rollbackDataOptions,
      support,
    })
    writeFragment(rollbackDataOptions, {
      label: "writeFragment Rollback Operation",
      next: null,
      rollbackDocType: support.rollbackDocType || "UserEntry",
    })
    if (rollbackDataOptions.data.review) {
      const { __typename } = JSON.parse(rollbackDataOptions.data.review)
      if (__typename === "MonthlyReview") {
        const { monthlyReview } = readQuery({ query: MONTHLY_REVIEW })
        verifyCacheAndNetworkSync(monthlyReview)
      }
      if (__typename === "YearlyReview") {
        const { yearlyReview } = readQuery({ query: YEARLY_REVIEW })
        verifyCacheAndNetworkSync(yearlyReview)
      }
    }
  } catch (err) {
    _throwRollbackError(err, "_performCacheRollback")
  }
}

function _updateCachedFields(options, ref = null) {
  const cacheId = ref
    ? client.cache.identify(ref)
    : client.cache.identify({
        __typename: options.data.__typename,
        id: options.id,
      })
  const fields = Object.keys(options.data).reduce((res, field) => {
    res[field] = function(currentValue) {
      const updatedFieldValue = options.data[field]
      // debugger
      return updatedFieldValue
    }
    return res
  }, {})
  client.cache.modify({
    id: cacheId,
    fields,
    /* broadcast: false // Include this to prevent automatic query refresh */
  })
}

/**
 * Updates the cached item on Query.root.userEntries, triggering React UI update
 * for all components watching the `GET_ENTRIES` query via the `useQuery` hook.
 *
 * @param {import("@apollo/client").DataProxy.WriteFragmentOptions<any, import("@apollo/client").OperationVariables>} options required options for writeFragment
 */
function _modifyQueryRootEntity(options) {
  try {
    client.cache.modify({
      fields: {
        userEntries(existing = []) {
          let idx = existing.findIndex(document => document.key === options.id),
            updatedDocuments = [...existing]
          if (isNumber(idx)) {
            updatedDocuments[idx] = {
              ...updatedDocuments[idx],
              ...options.data,
            }
          }
          return updatedDocuments
        },
      },
    })
  } catch (err) {
    console.warn(
      "LOG: [_modifyQueryRootEntity] failed with error: " + err.message
    )
    console.error(err)
    debugger //_
  }
}

function _deleteQueryRootEntity(options) {
  try {
    client.cache.modify({
      fields: {
        userEntries(existing = []) {
          let filtered = existing.filter(
              document => document.key !== options.id
            ),
            updatedDocuments = [...filtered]
          return updatedDocuments
        },
      },
    })
  } catch (err) {
    console.warn(
      "LOG: [_deleteQueryRootEntity] failed with error: " + err.message
    )
    console.error(err)
    debugger //_
  }
}

/**
 * A proxy for Apollo Cache `writeFragment`. Updates a cached document with a limited
 * number of it's fields.
 * See {@link https://www.apollographql.com/docs/react/caching/cache-interaction/#writequery-and-writefragment|Documentation}
 *
 * @param {import("apollo-cache").DataProxy.WriteFragmentOptions<any, import("apollo-boost").OperationVariables>} options required options for operation
 * @param {{
 *  label: string
 *  next: null|function
 *  rollbackDocType: "UserEntry"
 *  skipDiffCheck: boolean
 * }} support options label to provide error reference, other optiosn
 * @example
 * ```
 * cache.writePartialDocument({
 *  id: entry_id,
 *  fragment: gql`
 *    fragment SomeUniqueName on SomeTypeName {
 *      someField
 *    }
 *  `,
 *  data: updated_document_data
 * },
 * {label: "SomeSource", next: networkUpdateFunction?, rollbackDocType: "UserEntry", skipDiffCheck: false}
 * )
 * ```
 */
export function writeFragment(
  options,
  support = {
    label: "unlabeled",
    next: null,
    rollbackDocType: "UserEntry",
    skipDiffCheck: false,
  }
) {
  /** Read current data in case of required cache rollback due to network update callback failure */
  let rollbackDataOptions = support.next
    ? _getRollbackData(options, support)
    : {}

  try {
    const docHasChanges = support.skipDiffCheck
      ? true
      : diffFragment(options.id, options.data, "DiffFragmentDocument", "", {
          fragment: options.fragment,
        })
    /** Before operating, confirm the document has changes */
    if (docHasChanges) {
      if (!support.next) {
        client.cache.writeFragment(options)
        _modifyQueryRootEntity(options)
      } else if (support.next && typeof support.next === "function") {
        try {
          client.cache.writeFragment(options)
          _modifyQueryRootEntity(options)
          support.next(options, function() {
            _performCacheRollback(rollbackDataOptions, support)
          })
        } catch (err) {
          debugger //_
          _performCacheRollback(rollbackDataOptions, support)
        }
      }
    } else {
      // console.log(
      //   `LOG: [${support.label ||
      //     "writeFragment"}] no changes detected for item:${options.id}.`
      // )
    }
  } catch (err) {
    console.error(err)
    debugger //_
    throw Error(`Cache writeFragment failed from \`${support.label}\``)
  }

  /** Contains options to read or write the updated document in cache */
  return rollbackDataOptions
}

export function deleteCacheDocument(options) {
  return _deleteQueryRootEntity(options)
}

export function writeNewSortedDocument(
  options,
  support = {
    label: "writeSortedFragment",
    next: null,
    rollbackDocType: "UserEntry",
    orderBy: "date",
  }
) {
  let currentDocuments

  //TODO: Extract and improve
  /** Naive validation of options */
  const valid = options && options.data && options.fragment
  if (!valid) {
    console.warn(
      "LOG: [writeNewSortedDocument] provided invalid options parameter"
    )
    console.log(options)
    debugger //_
    return
  }

  /** Generate a new UUID for the document, if none provided */
  options.id = !options.id ? uuidv4() : options.id

  /** Extract the typename of the document */
  const typeName = options.data.__typename

  /** Requires a typename */
  if (!typeName) {
    console.warn(
      "LOG: [writeNewSortedDocument] no `__typename` property found on document."
    )
    console.log(options)
    debugger //_
    return
  }

  /** Get all the related documents from cache */
  switch (typeName) {
    case "UserEntry":
      currentDocuments =
        client.readQuery({ query: GET_ENTRIES })?.userEntries || []
      break
    default:
      console.warn(
        `LOG: [writeNewSortedDocument] invalid typename provided: ${typeName}`
      )
      debugger //_
      return
  }

  /** Security check to see if document exists in cache already */
  const existingDocument = (currentDocuments || []).some(
    document => document.key === options.id
  )
  if (existingDocument) {
    console.warn(
      `LOG: [writeNewSortedDocument] document ID provided (${options.id}) already exists!`
    )
    console.log(currentDocuments.userEntries)
    debugger //_
    return
  }

  /** Create a new document */
  const newDocument = prepareDocument(
    { ...options.data, key: options.id },
    typeName
  )
  let newDocuments = [...(currentDocuments || []), newDocument]

  /** Add document to current stack and sort them by date */
  //TODO: Turn this into sort callback parameter to be able to sort by anything
  newDocuments = newDocuments.sort(function(a, b) {
    return new Date(b.date) - new Date(a.date)
  })

  /** Update the fragment on the flat lookup table */
  client.writeFragment({
    id: newDocument.key,
    fragment: USER_ENTRY_UPDATE(),
    data: newDocument,
  })

  /** Write the new document array to the Query.root.userEntries table */
  client.writeQuery({
    query: GET_ENTRIES,
    data: {
      userEntries: newDocuments,
    },
  })

  // debugger
  // 🦄  perhaps here we could trigger a reactive var, or make a readQuery that triggers a reactive var, to then trigger an update of data (or UI) elsewhere where required
  return { id: options.id, document: newDocument, documents: newDocuments }
}

/**
 * Prepares a document for being written to the cache, adding any missing
 * fields with default values.
 *
 * @param {any} data the document's data
 * @param {"UserEntry"} typeName the typename of the document in cache
 */
export function prepareDocument(data = {}, typeName = "UserEntry") {
  let document
  try {
    switch (typeName) {
      case "UserEntry":
        document = ENTRY.split("\n").reduce((res, field) => {
          switch (field) {
            case "tags":
              res[field] =
                data.tags && isString(data.tags)
                  ? data.tags.split(",")
                  : data.tags
              break
            case "platform":
              res[field] = data.platform || "web"
              break
            default:
              res[field] = data[field] || ""
              break
          }
          // debugger
          return res
        }, {})
        break
      default:
        document = data
        break
    }
    document.__typename = typeName
  } catch (err) {
    console.warn(`LOG: [prepareDocument] failed with error: ${err.message}`)
    console.error(err)
    debugger //_
    return data
  }
  return document
}

const resetStore = () => client.cache.reset()
const clearStore = () => client.clearStore()

const cache = {
  reset: resetStore,
  clear: clearStore,
  diff: { query: diffQuery, fragment: diffFragment },
  prepareWriteDocument: prepareDocument,
  readQuery,
  readPartialDocument: readFragment,
  writePartialDocument: writeFragment,
  addSortedDocument: writeNewSortedDocument,
  deleteDocument: deleteCacheDocument,
}

// Expose to global in development
if (typeof window !== "undefined") {
  window._gql = gql
  window._cache = cache
}

export default cache
